import React from 'react';
import { Countdown } from './Countdown';
import { Eyebrow } from './Eyebrow';
const CLAIMED_PERCENT = 68;
export function LaunchUrgency() {
  return <section aria-labelledby="urgency-heading" className="border-y border-ember/40 bg-ember-dark py-12 sm:py-20" data-id="element-203" data-mp="meu5c5q9gld0">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-204" data-mp="w6zw5c4s0wqm">
        <div data-id="element-205" data-mp="8gng1dzdntoy">
          <Eyebrow data-id="element-206" data-mp="8i89f09yh6l8">Limited-time offer</Eyebrow>
          <h2 id="urgency-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-5xl" data-id="element-207" data-mp="8j9odfu3ed88">
            Launch pricing <span className="text-amber" data-id="element-208" data-mp="himvi1uqupps">expires in</span>
          </h2>
          <div className="mt-6" data-id="element-209" data-mp="dfql2yfcxzwx">
            <Countdown initialSeconds={86347} data-id="element-210" data-mp="deoxxvl2hmyu" />
          </div>
          <p className="mt-6 max-w-md text-sm text-cream-muted" data-id="element-211" data-mp="1swh828ucrf0r">
            Launch pricing ends today. After that, pricing returns to $97.
          </p>
        </div>

        <div className="rounded-2xl border border-ember/40 bg-night-950 p-5 sm:p-7" data-id="element-212" data-mp="1oxrm3rv90p5i">
          <div className="flex items-baseline justify-between gap-4" data-id="element-213" data-mp="1ykrcy1mpbb42">
            <span className="text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-214" data-mp="23gezsadpns6e">
              Limited availability &mdash; today only
            </span>
            <span className="font-display text-3xl leading-none text-amber" data-id="element-215" data-mp="2chd6x1jg4ft7">{CLAIMED_PERCENT}%</span>
          </div>
          <div className="mt-5 h-2.5 w-full overflow-hidden rounded-full bg-night-600" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Launch allocation claimed" data-id="element-216" data-mp="1ftgqpxrx7mii">
            <div className="h-full rounded-full bg-amber" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-217" data-mp="1tl4yxpz1tqu7" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-label text-cream-muted" data-id="element-218" data-mp="w3wj2qnkkkc2">Claimed</p>
        </div>
      </div>
    </section>;
}